import { Link } from "react-router-dom";
import { CONTACT_EMAIL } from "@/lib/api";

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-espresso text-sand">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-20 md:grid-cols-12 lg:px-10">
            <div className="md:col-span-5">
                <p className="font-serif text-4xl font-light tracking-tight text-gold">
                    Kicha<span className="italic text-sand/50">zone</span>
                </p>
                <p className="mt-4 max-w-sm text-sm leading-relaxed text-sand/60">
                    Handmade purses, jewelry, home goods, and carefully selected finds — each created or chosen to bring beauty, elegance, and a touch of luxury into your everyday life.
                </p>
            </div>
            <div className="md:col-span-2">
                <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.25em] text-sand/50">Explore</p>
                <div className="flex flex-col gap-3 font-mono text-xs uppercase tracking-[0.2em]">
                    <Link to="/shop" data-testid="footer-shop-link" className="transition-colors hover:text-gold">Shop</Link>
                    <Link to="/" data-testid="footer-home-link" className="transition-colors hover:text-gold">Home</Link>
                    <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-gold">Privacy</Link>
                    <Link to="/admin" data-testid="footer-admin-link" className="text-sand/40 transition-colors hover:text-gold">Maker login</Link>
                </div>
            </div>
            <div className="md:col-span-2">
                <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.25em] text-sand/50">Say hello</p>
                <div className="flex flex-col gap-3 font-mono text-xs uppercase tracking-[0.2em]">
                    <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link" className="transition-colors hover:text-gold">{CONTACT_EMAIL}</a>
                </div>
                <p className="mt-6 max-w-xs font-mono text-[10px] uppercase leading-relaxed tracking-[0.2em] text-sand/50" data-testid="footer-custom-products-note">
                    For custom products please email <a href={`mailto:${CONTACT_EMAIL}`} className="text-sand transition-colors hover:text-gold">{CONTACT_EMAIL}</a>
                </p>
            </div>
            <div className="md:col-span-3">
                <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.25em] text-sand/50">Returns</p>
                <p className="max-w-xs text-sm leading-relaxed text-sand/60" data-testid="footer-return-policy">
                    We offer a 15-day return policy. If you're not in love with your piece, email us within 15 days of delivery — items must be unused and in their original condition.
                </p>
                <Link to="/returns" data-testid="footer-returns-page-link" className="mt-4 inline-block font-mono text-xs uppercase tracking-[0.2em] transition-colors hover:text-gold">
                    Return policy &amp; steps
                </Link>
                <a href={`mailto:${CONTACT_EMAIL}?subject=Return%20request`} data-testid="footer-return-link" className="mt-3 inline-block font-mono text-xs uppercase tracking-[0.2em] text-sand/50 transition-colors hover:text-gold">
                    Start a return
                </a>
            </div>
        </div>
        <div className="border-t border-sand/10">
            <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 font-mono text-[10px] uppercase tracking-[0.25em] text-sand/40 sm:flex-row sm:justify-between lg:px-10">
                <span>© 2026 Kichazone</span>
                <span>Made slowly, by hand</span>
            </div>
        </div>
    </footer>
);
